module.exports = __webpack_public_path__ + "static/media/29ADMSPC18.a3e32f27.jpg";